import { useIntl } from "react-intl";
import { SupportedLanguages } from "../common/controls/lang-switcher";
import type { Company, CvData, ICVFileData } from "../data/cv-data";

import en from "../data/my-data--en.json";
import ru from "../data/my-data--ru.json";
// import { getUserLocalization } from "./utils";




export type ILanguageCVDataDictionary = {
  [language in SupportedLanguages]: ICVFileData;
};


export const CV_DATA: ILanguageCVDataDictionary = {
  ru: ru as ICVFileData,
  en: en as ICVFileData,
};



const mapLocaleToLang = (locale: string): SupportedLanguages => {
  const short = locale.split('-')[0] as SupportedLanguages;
  if (short === 'ru' || short === 'en') return short;
  return 'en'; // дефолт
};

export const useCvDataProfile = (): CvData => {
  const { locale } = useIntl();
  const lang = mapLocaleToLang(locale);
  return CV_DATA[lang].profile;
};

export const useCvDataExperience = (): Company[] => {
  const { locale } = useIntl();
  const lang = mapLocaleToLang(locale);
  return CV_DATA[lang].experience;
};